<template>
  <notLoginLayout class="forget-password">
    <b-form>
      <b-form-group
        label="新密碼"
        label-for="forget-new-password"
        class="required-icon-star"
      >
        <b-form-input
          id="forget-new-password"
          :value="$store.getters.verifyNewAccount.password"
          @input="$store.commit('verifyNewAccountNewPassword', $event)"
          :state="verifyNewPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="確認新密碼"
        label-for="forget-confirm-password"
        class="required-icon-star"
      >
        <b-form-input
          id="forget-confirm-password"
          :value="$store.getters.verifyNewAccount.password_confirmation"
          @input="
            $store.commit('verifyNewAccountNewPasswordConfirmation', $event)
          "
          :state="verifyConfirmPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
    </b-form>
    <div class="forget text-right">
      <b-button @click="verifyForm" class="mr-3" type="submit" variant="primary"
        >修改</b-button
      >
      <b-button
        @click="$router.push({ name: 'login' })"
        type="submit"
        variant="dark"
        >取消</b-button
      >
    </div>
  </notLoginLayout>
</template>

<script>
import notLoginLayout from "@/layout/NotLoginLayout.vue";
import mixinsVerify from "@/utility/mixinsVerify.js";
export default {
  components: {
    notLoginLayout
  },
  mixins: [mixinsVerify],
  methods: {
    verifyForm() {
      this.verifyNewPassword =
        this.hasValue(this.$store.getters.verifyNewAccount.password) === null
          ? this.passwordRegexp(this.$store.getters.verifyNewAccount.password)
          : false;
      this.verifyConfirmPassword =
        this.hasValue(
          this.$store.getters.verifyNewAccount.password_confirmation
        ) === null
          ? this.passwordRegexp(
              this.$store.getters.verifyNewAccount.password_confirmation
            )
          : false;
      if (
        this.verifyNewPassword === false ||
        this.verifyConfirmPassword === false
      ) {
        return;
      } else if (
        this.isSameInPassword(
          this.$store.getters.verifyNewAccount.password,
          this.$store.getters.verifyNewAccount.password_confirmation
        ) === false
      ) {
        this.verifyConfirmPassword = false;
        alert("請檢查「確認新密碼」欄位，與「新密碼」欄位不相同");
      } else this.onSubmit();
    },
    onSubmit() {
      this.$store
        .dispatch("createNewPassword")
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(e => {
          console.warn(">>>> createNewPassword error", e);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
